// extracted by mini-css-extract-plugin
module.exports = {"Container":"Contacts_Container__3BGqJ","form":"Contacts_form__1ra0k","Submit":"Contacts_Submit__1s1FM","Error":"Contacts_Error__3ZBUK"};